/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Zone from 'astro/server/zone';


export default class
{
  constructor (scope)
  {
    this.scope = scope;

    this.collection = [];
  }


  insert (zone)
  {
    this.collection.push(zone);
  }


  eachZone (callback)
  {
    for (const zone of this.collection)
    {
      callback(zone);
    }
  }


  getTotalCount ()
  {
    return this.collection.length;
  }


  getMajorityCount ()
  {
    return Math.ceil(0.5 * this.getTotalCount());
  }


  getZone (coords)
  {
    const id = coords.toString();

    for (const zone of this.collection)
    {
      if (zone.getType().getID() === id)
      {
        return zone;
      }
    }

    return null;
  }


  getCenterZone ()
  {
    return this.getZone(this.scope.getCass().getCenter());
  }


};
